import { formatDisplayNumber } from "../../../../../../../../../utility/utils";
import { ErrorSwalHtml } from "../../../../../../../Utils/Utils/DecisionSwal";

export const MostrarMensajePaletizacionesSinEnviar = () => {
    const html = `
        <div class="text-start text-sm">
            <p class="mb-0">
                    Hay paletizaciones sin enviar a bodega.
            </p>

            <p class="mb-0 mt-2">
                Para proceder, envíe las paletizaciones pendientes a bodega o elimínelas si no son necesarias.
            </p>
        </div>`;
    ErrorSwalHtml(html, "Volver");
};

export const MostrarMensajePaletizacionesPendientes = () => {
    const html = `
        <div class="text-start text-sm">
            <p class="mb-0">
                    Hay paletizaciones pendientes de revisión en bodega.
            </p>

            <p class="mb-0 mt-2">
                Para proceder, es necesario que bodega revise las paletizaciones pendientes.
            </p>
        </div>`;
    ErrorSwalHtml(html, "Volver");
};

export const MostrarMensajePaletizacionPendiente = (
    turnoActualPeso = 0,
    turnoAnteriorPeso = 0,
) => {
    const html = `
        <div class="text-start text-sm">
            <p>
                <strong>
                    Para poder cerrar paletización debe dejar el turno actual y 
                    el anterior en cero
                </strong>
            </p>

            <table class="table">
                <tbody class="react-bs-table-bordered">
                    <tr>
                        <th class="bg-white text-sm">Peso turno actual</th>
                        <th class="bg-white text-sm">Peso turno anterior</th>
                    </tr>
                    <tr>
                        <td class="bg-white text-sm">
                        ${formatDisplayNumber(turnoActualPeso, 2)} Kg</td>
                        <td class="bg-white text-sm">
                        ${formatDisplayNumber(turnoAnteriorPeso, 2)} Kg</td>
                    </tr>
                </tbody>
            </table>
        </div>`;
    ErrorSwalHtml(html, "Volver");
};
